<template>
  <span
    v-if="type?.toLowerCase() === 'pms'"
    class="rounded-md px-3 text-xs py-1 text-[var(--yellow100)] bg-[var(--yellow50)] font-semibold"
    >PMS</span
  >
  <span
    v-if="type?.toLowerCase() === 'dpk'"
    class="px-3 text-xs py-1 ml-1 rounded-md text-[var(--green100)] bg-[var(--green50)] font-semibold"
    >DPK</span
  ><span
    v-if="type?.toLowerCase() === 'ago'"
    class="px-3 text-xs py-1 ml-1 rounded-md text-[var(--blue100)] bg-[var(--blue50)] font-semibold"
    >AGO</span
  ><span
    v-if="type?.toLowerCase() === 'lpg'"
    class="px-3 text-xs py-1 ml-1 rounded-md text-gray-500 bg-[var(--black50)] font-semibold"
    >LPG</span
  ><span
    v-if="type?.toLowerCase() === 'atk'"
    class="px-3 text-xs py-1 ml-1 rounded-md text-[var(--red100)] bg-[var(--red50)] font-semibold"
    >ATK</span
  >

  <span
    v-if="type?.toLowerCase() === 'lpfo'"
    class="px-3 py-1 ml-1 text-xs font-semibold text-purple-800 bg-purple-200 rounded-md"
    >LPFO</span
  >

  <span
    v-if="
      type?.toLowerCase() !== 'lpfo' &&
      type?.toLowerCase() !== 'pms' &&
      type?.toLowerCase() !== 'dpk' &&
      type?.toLowerCase() !== 'ago' &&
      type?.toLowerCase() !== 'atk' &&
      type?.toLowerCase() !== 'lpg'
    "
    class="px-3 py-1 ml-1 text-xs font-semibold text-pink-800 bg-pink-200 rounded-md"
    >{{ type?.toUpperCase() }}</span
  >
</template>

<script>
export default {
  props: ["type"],
};
</script>

<style></style>
